<div class="tabs-detail-header">
    <div class="title">
        Hyperlinks
        <cerrix-instructions-icon
            [instructionText]="'hyperlinks.hyperlinksInformation' | t"
            [showText]="false"
        ></cerrix-instructions-icon>
    </div>
    @if (canEdit) {
        <cerrix-button
            class="add-hyperlink-button"
            data-uiid="asset-hyperlink-add"
            buttonType="secondary"
            secondaryColor="filled-blue"
            buttonSize="big"
            icon="link"
            iconPosition="left"
            [text]="'hyperlinks.addHyperlinkButton' | t"
            (click)="onAddHyperlink()"
        >
        </cerrix-button>
    }
</div>
<div class="hyperlinks">
    @if (this.model.hyperlinks.length !== 0) {
        @for (hyperlink of model.hyperlinks; track $index) {
            <div class="hyperlink-item" data-uiid="asset-hyperlink-item">
                <a
                    [href]="getHyperlinkHref(hyperlink.hyperlinkUrl)"
                    rel="noopener noreferrer"
                    target="_blank"
                    class="hyperlink-link"
                    data-uiid="asset-hyperlink-link"
                >
                    <mat-icon class="hyperlink-icon" svgIcon="link-external"></mat-icon>
                    <div class="hyperlink-name">
                        {{ hyperlink.name }}
                    </div>
                    @if (hyperlink.description) {
                        <mat-icon
                            [cerrixHover]="hyperlinkDescriptionCard"
                            class="hyperlink-description-icon"
                            data-uiid="asset-hyperlink-description-icon"
                            svgIcon="chat"
                        >
                            <ng-template #hyperlinkDescriptionCard>
                                <div class="hyperlink-description-text">
                                    {{ hyperlink.description }}
                                </div>
                            </ng-template>
                        </mat-icon>
                    }
                </a>
                <app-cerrix-kebab-menu
                    [menuItems]="getKebabItems(hyperlink)"
                ></app-cerrix-kebab-menu>
            </div>
        }
    }
</div>

<app-cerrix-add-hyperlink-dialog
    [name]="this.openHyperlinkDialogName"
    [openReason]="this.openHyperlinkDialogReason"
    (cancelDialog)="closeCancel()"
    (confirmDialog)="saveHyperlink($event)"
></app-cerrix-add-hyperlink-dialog>

<cerrix-confirm-dialog
    [name]="confirmRemoveHyperlinkDialogName"
    dataUiid="asset-management-remove-hyperlink-confirm"
    icon="warning"
    [title]="'hyperlinks.removeHyperlinkDialogTitle' | t"
    [description]="'hyperlinks.removeHyperlinkDialogDescription' | t"
    [cancelText]="'hyperlinks.removeHyperlinkDialogCancelText' | t"
    [confirmText]="'hyperlinks.removeHyperlinkDialogConfirmText' | t"
    (cancel)="removeHyperlinkCancel()"
    (confirm)="removeHyperlinkConfirm()"
    [waitingOnResult]="removeHyperlinkLoading"
    [showResultText]="removeHyperlinkLoading"
    class="dialog-remove-hyperlink-confirm"
>
    <div class="dont-ask-me-again-input">
        <input
            type="checkbox"
            name="dontAskMeAgain"
            [checked]="dontAskMeAgainSelected"
            (change)="dontAskMeAgainSelected = $event.target.checked"
        />
        <label for="dontAskMeAgain">{{
            "hyperlinks.removeHyperlinkDialogDontAskAgain" | t
        }}</label>
    </div>
</cerrix-confirm-dialog>
